import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-331a9fe3"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]

import versionInfo from '@/version.json';
import { Version } from '@/models/version';


export default /*#__PURE__*/_defineComponent({
  __name: 'Version',
  setup(__props) {

const version = new Version(versionInfo);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "version",
    textContent: _toDisplayString(_unref(version).version)
  }, null, 8, _hoisted_1))
}
}

})